import { CKEditorEventAction, useCKEditor } from 'ckeditor4-react';
import React, { useEffect, useRef } from 'react';
import './style.scss';
import { useUploadImage } from './hooks/useUploadImage/useUploadImage';

type Props = {
  event?: string;
  disable?: boolean;
  value?: string;
  config: object;
  initContent?: string;
  keyId?: string;
  onChangeEditor: (content: string, ...restParams: any[]) => void;
};
let focus = false;
function CkEditorWord4({
  disable = false,
  event = CKEditorEventAction.change,
  value,
  config,
  onChangeEditor,
  initContent,
  keyId,
}: Props) {
  const refInputFileImage = useRef<any>();
  const refInputFileVideo = useRef<any>();
  const refInputFileAudio = useRef<any>();
  const { uploadImage } = useUploadImage();
  const [element, setElement] = React.useState<HTMLElement | null>(null);

  const { editor } = useCKEditor<'beforeLoad' | 'change' | 'paste'>({
    element,
    config,
    editorUrl: '/ckeditor/ckeditor.js',
    initContent: initContent ?? '',
    dispatchEvent: async ({ type, payload }) => {
      // const range = payload.editor.createRange();
      // range.moveToElementEditEnd(range.root);
      // payload.editor.getSelection().selectRanges([range]);
      if (type === CKEditorEventAction.beforeLoad) {
        payload.plugins.addExternal('ckeditor_wiris', '/mathtype/plugin.js');
        payload.config['extraPlugins'] = 'ckeditor_wiris';
        payload.config['allowedContent'] = true;
        if (!payload.plugins.get('niw_btn')) {
          payload.plugins.add('niw_btn', {
            init: function (editor: any) {
              editor.addCommand('uploadImg', {
                exec: function () {
                  if (editor) {
                    (document.querySelector(`#${editor.id}_inp_image_file`) as HTMLElement).click();
                  }
                },
              });
              editor.addCommand('uploadVideo', {
                exec: function () {
                  refInputFileVideo.current?.click();
                },
              });
              editor.addCommand('uploadAudio', {
                exec: function () {
                  refInputFileAudio.current?.click();
                },
              });
              editor.ui.addButton('drawShape', {
                label: 'Vẽ hình',
                command: 'drawShape',
                icon: '/assets/images/ic_svgedit.png',
                toolbar: 'insert',
              });
              editor.ui.addButton('uploadImg', {
                label: 'Tải hình ảnh',
                command: 'uploadImg',
                icon: '/assets/images/ic_uploadimage.png',
                toolbar: 'insert',
              });
              editor.ui.addButton('uploadVideo', {
                label: 'Tải video',
                command: 'uploadVideo',
                icon: '/assets/images/ic_uploadvideo.png',
                toolbar: 'insert',
              });
              editor.ui.addButton('uploadAudio', {
                label: 'Tải audio',
                command: 'uploadAudio',
                icon: '/assets/images/ic_mp3.png',
                toolbar: 'insert',
              });
            },
          });
        }
      }

      if (type === CKEditorEventAction.paste) {
        const files = payload?.data?.dataTransfer?._?.files;
        if (files && files.length > 0) {
          const form = new FormData();
          form.append('upload', files[0]);
          const resUpload: any = await uploadImage(form);

          if (payload.editor) {
            payload.editor.insertHtml(`<img src="${resUpload.data.url}" alt="${resUpload.data.fileName}" />`);
          }
        }
      }

      if (type === event) {
        if (payload.editor.getData().trim() !== value) {
          onChangeEditor(payload.editor.getData().trim(), payload.editor);
        }
      }
      if (type === CKEditorEventAction.instanceReady) {
        payload.editor.setReadOnly(disable);
        payload.editor.setData(initContent ?? value);
        payload.editor.edit_data_id = keyId;
      }
    },
    subscribeTo: ['beforeLoad', 'change', 'focus', 'blur', 'instanceReady', 'paste'],
  });

  const handleUploadImage = async (e: any) => {
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0];
      const form = new FormData();
      form.append('upload', file);
      const resUpload: any = await uploadImage(form);
      if (editor) {
        editor.insertHtml(`<img src="${resUpload.data.url}" alt="${resUpload.data.fileName}" />`);
      }
    }
  };

  useEffect(() => {
    if (editor) {
      if (value) {
        editor.setData(value);
      } else {
        editor.setData('');
      }
      editor.edit_data_id = keyId;
    }
  }, [keyId]);

  return (
    <div>
      <div ref={setElement} />
      <input
        id={editor ? `${editor.id}_inp_image_file` : `${keyId}_inp_image_file`}
        ref={refInputFileImage}
        type="file"
        style={{ display: 'none' }}
        accept="image/*"
        onChange={(e) => handleUploadImage(e)}
      />
      <input
        ref={refInputFileVideo}
        type="file"
        style={{ display: 'none' }}
        accept="video/mp4,video/x-m4v,video/*"
        onChange={(e) => {
          if (e.target.files && e.target.files.length) {
            const file = e.target.files[0];
            const form = new FormData();
            form.append('upload', file);
            uploadImage(form);
          }
        }}
      />
      <input
        ref={refInputFileAudio}
        type="file"
        style={{ display: 'none' }}
        accept="audio/*"
        onChange={(e) => {
          if (e.target.files && e.target.files.length) {
            const file = e.target.files[0];
            const form = new FormData();
            form.append('upload', file);
            uploadImage(form);
          }
        }}
      />
    </div>
  );
}

export default React.memo(CkEditorWord4);
